import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import Attractor from "./components/Attractor";
import SectionSelector from "./components/SectionSelector";
import Section from "./components/Section";
import Container from "react-bootstrap/Container";
import { getClassName } from "./helpers/utils";

import allDetailGroupings from "./data/detailGroupings.json";
import allSections from "./data/sections.json";
import allSuccessStories from "./data/successStories.json";

import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/global.scss";
import userEvent from "@testing-library/user-event";

function App() {
  let defaultHeader = "What can we do?";

  const [attractorActive, setAttractorActive] = useState(true);
  const [selectedSection, setSelectedSection] = useState();
  const [selectedDetail, setSelectedDetail] = useState();

  //Preprocess data
  useEffect(() => {}, []);

  //Inactivity timer
  useEffect(() => {
    let inactivityTimer;
    let videoTimer; 

    videoTimer = setInterval(() => {
     checkForRunningVideo();
    }, 1000);

    const checkForRunningVideo = () => {
      let thisVideo = document.querySelector(".active.carousel-item video");
      if (thisVideo !== null && thisVideo.paused === false) {
        handleDocumentInteraction();
      } 
    };

    const handleDocumentInteraction = () => {
      clearTimeout(inactivityTimer);
      
      inactivityTimer = setTimeout(() => {
        doReset();
      }, 60000);
    };

    document.addEventListener("click", handleDocumentInteraction);

    return () => {
      document.removeEventListener("click", handleDocumentInteraction);
    };
  }, []);

  const doReset = () => {
    setAttractorActive(true);
    setSelectedSection();
  };

  const onHomeClicked = () => {
    setSelectedSection();
  };

  const onStartClicked = () => {
    setAttractorActive(false);

  };

  const onSectionClicked = (sid) => {
    var newSection = allSections.filter((d) => {
      return d.id === sid;
    })[0];
    setSelectedSection(newSection);
  };

  return (
    <div className="asset">
      <Header
        title={selectedSection ? selectedSection.title : defaultHeader}
        showHome={selectedSection ? true : false}
        parentEvent={onHomeClicked}
      ></Header>
      {/* {
        (() => {
          if(attactorActive)
          {
            return (
              <Attractor parentEvent={onStartClicked} ></Attractor>
            )
          }
          else if (selectedSection){
            return (
              <Section section={selectedSection} homeEvent={onHomeClicked}></Section>
            )
          }
          else if()
        })
      } */}
      {attractorActive ? (
        <Attractor parentEvent={onStartClicked}></Attractor>
      ) : selectedSection !== undefined ? (
        <Section section={selectedSection} homeEvent={onHomeClicked}></Section>
      ) : (
        <SectionSelector
          sections={allSections}
          detailGroupings={allDetailGroupings}
          parentEvent={onSectionClicked}
        ></SectionSelector>
      )}
    </div>
  );
}

export default App;
